import { PortalScope } from "../models/theme";

export const isServiceLink = (
  scope: PortalScope | null,
  targetServiceId: string | null
): boolean => {
  return scope?.type === "SERVICE" && Boolean(targetServiceId);
};
// The frame's provider line: the organisation the page was opened for. A
// SERVICE scope's label is the service itself, and LANDING has no tenant.
export const frameProvider = (scope: PortalScope | null | undefined): string =>
  scope && scope.type !== "SERVICE" && scope.type !== "LANDING"
    ? scope.label
    : "";
